<template>
  <nav class="dashboard-nav">
    <div class="container">
      <ul class="dashboard-nav__list flex gap-s">
        <li v-for="navItem of navList">
          <saffron-link v-if="!navItem.scrollTargetSelector"
            v-slot="{ isActive, href, parentActive, exactActive, navigate }"
            :key="navItem.label"
            class="plain-link"
            :class="navItem.class"
            :to="navItem.to">
            <span>{{ translate(navItem.label) }}</span>
          </saffron-link>
          <span v-else class="cursor-pointer" :class="{ 'active': selectedIndex === navItem.index }"  @click="scrollToElement(navItem.scrollTargetSelector, navItem.index)">{{ translate(navItem.label) }}</span>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script> 
export default {
  props: {
    navList: {
      type: [Array],
      default: [],
    },
  },
  data: function () {
    return {
      selectedIndex: 0
    };
  },
  methods: {
    async scrollToElement(el) {
      if (utilities.isSSR()) {
        return true;
      }

      // scroll just above the needed section 
      // so it actually feels like you see everything
      // other components use 120 - should be a fixed property once decided whats better
      const offset = -160;
      const y = document.getElementById(el).getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: y, behavior: "smooth" });  
    },
  },
  mounted() {
    // if there is at least one scroll element, the scroll function will run
    if (utilities.isSSR() || !this.navList.find(element => element.scrollTargetSelector)) {
        return;
    }

    // upon scrolling in the page,
    document.getElementsByTagName("body")[0].onscroll = () => {
      document.querySelectorAll('.section').forEach(element => {
        if (element.getBoundingClientRect().top < 170 && element.getBoundingClientRect().top > -60) {
          // 'article-section-{number}'
          this.selectedIndex = parseInt(element.id.split("-")[2])
        }

      })
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard-nav {
  background-color: var(--c-gray-5);
  padding: var(--margin-m) 0;
  color: var(--c-bg);
  position: sticky;
  width: 100%;
  border-bottom: 1px solid var(--c-gray);
  box-shadow: var(--box-shadow);
  overflow-x: auto;
  overflow-y: hidden;
  z-index: var(--z-top-2);

  top: 98px;

  @media (max-width: 1024px) {
    top: 75.8px;
  }

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      display: inline-block;
      white-space: nowrap;
      &::after {
        content: "\00B7";
        color: var(--c-alt);
        margin-inline-start: var(--margin-xl);
        margin-inline-end: var(--margin-xl);
      }

      &:last-of-type {
        &::after {
          display: none;
        }
      }
    }

    a {
      position: relative;
      display: inline-block;
      color: var(--c-bg);

      &:hover,
      &.active:not(.requires-exact-active),
      &.router-link-exact-active {
        color: var(--c-lead);
      }
    }

    span:hover {
      color: var(--c-lead);
    }

    .active {
      color: var(--c-lead);
    }
  }
}
</style>
